export interface LLMModel {
  value: string;
  label: string;
  price: string;
  provider: string;
}

export interface LLMModelCategory {
  category: string;
  description: string;
  models: LLMModel[];
  useCase: string;
}

export const modelCategories: LLMModelCategory[] = [
  {
    category: "🟢 Super Cheap",
    description: "Pennies per million, 'functional' only",
    models: [
      { value: 'meta-llama/Llama-3.2-3B-Instruct-Turbo', label: 'Llama 3.2 3B Instruct-Turbo', price: '~$0.06 per MTok', provider: 'Together.ai' },
      { value: 'meta-llama/Llama-3.2-1B-Instruct-Turbo', label: 'Llama 3.2 1B Instruct-Turbo', price: '~$0.04 per MTok', provider: 'Together.ai' },
      { value: 'gemini-1.5-flash', label: 'Google Gemini 1.5 Flash', price: '$0.075 in / $0.30 out per MTok', provider: 'Google' },
    ],
    useCase: "First pass on suitability filters, bulk auto-tagging where you can tolerate misclassifications"
  },
  {
    category: "🟡 Cheap",
    description: "Workhorse, solid accuracy at scale",
    models: [
      { value: 'meta-llama/Meta-Llama-3.1-8B-Instruct-Turbo', label: 'Llama 3.1 8B Instruct-Turbo', price: '$0.18 per MTok', provider: 'Together.ai' },
      { value: 'mistralai/Mistral-7B-Instruct-v0.1', label: 'Mistral 7B Instruct', price: '$0.20 per MTok', provider: 'Together.ai' },
      { value: 'gpt-4o-mini', label: 'OpenAI GPT-4o Mini', price: '$0.15 in / $0.60 out per MTok', provider: 'OpenAI' },
      { value: 'sonar', label: 'Perplexity Sonar (Default)', price: '$0.20 in / $0.20 out per MTok', provider: 'Perplexity' },
      { value: 'llama-3.1-sonar-small-128k-chat', label: 'Perplexity Sonar Small (Chat)', price: '$0.20 in / $0.20 out per MTok', provider: 'Perplexity' },
    ],
    useCase: "Day-to-day suitability scoring, auto-tagger where tone matters, bulk CRM enrichments"
  },
  {
    category: "🔵 Run-of-the-Mill",
    description: "Balanced, your 4o-mini replacement",
    models: [
      { value: 'gpt-4o', label: 'OpenAI GPT-4o', price: '$2.50 in / $10 out per MTok', provider: 'OpenAI' },
      { value: 'claude-3-5-haiku-20241022', label: 'Claude 3.5 Haiku', price: '$1 in / $5 out per MTok', provider: 'Anthropic' },
      { value: 'meta-llama/Meta-Llama-3.1-70B-Instruct-Turbo', label: 'Llama 3.1 70B Instruct-Turbo', price: '$0.88 per MTok', provider: 'Together.ai' },
      { value: 'llama-3.1-sonar-large-128k-online', label: 'Perplexity Sonar Large (Online)', price: '$1 in / $1 out per MTok', provider: 'Perplexity' },
      { value: 'llama-3.1-sonar-large-128k-chat', label: 'Perplexity Sonar Large (Chat)', price: '$1 in / $1 out per MTok', provider: 'Perplexity' },
      { value: 'gemini-2.0-flash-exp', label: 'Google Gemini 2.0 Flash (Experimental)', price: 'Experimental pricing', provider: 'Google' },
    ],
    useCase: "Default choice for dashboard UI where you want reliability, auto-tagging live inbound replies"
  },
  {
    category: "🔴 Advanced",
    description: "Premium models for harder edge cases",
    models: [
      { value: 'claude-3-5-sonnet-20241022', label: 'Claude 3.5 Sonnet', price: '$3 in / $15 out per MTok', provider: 'Anthropic' },
      { value: 'o1-mini', label: 'OpenAI o1-mini', price: '$3 in / $12 out per MTok', provider: 'OpenAI' },
      { value: 'meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo', label: 'Llama 3.1 405B Instruct-Turbo', price: '$5 per MTok', provider: 'Together.ai' },
      { value: 'grok-beta', label: 'xAI Grok Beta', price: '$5 in / $15 out per MTok', provider: 'xAI' },
      { value: 'grok-vision-beta', label: 'xAI Grok Vision Beta', price: '$5 in / $15 out per MTok', provider: 'xAI' },
      { value: 'llama-3.1-sonar-huge-128k-online', label: 'Perplexity Sonar Huge (Online)', price: '$5 in / $5 out per MTok', provider: 'Perplexity' },
      { value: 'llama-3.1-sonar-huge-128k-chat', label: 'Perplexity Sonar Huge (Chat)', price: '$5 in / $5 out per MTok', provider: 'Perplexity' },
    ],
    useCase: "Evaluation runs, important decision points (high-value accounts), complex classification"
  },
  {
    category: "🟣 Most Advanced",
    description: "Flagships, overkill for bulk",
    models: [
      { value: 'o1-preview', label: 'OpenAI o1-preview', price: '$15 in / $60 out per MTok', provider: 'OpenAI' },
      { value: 'claude-3-opus-20240229', label: 'Claude 3 Opus', price: '$15 in / $75 out per MTok', provider: 'Anthropic' },
      { value: 'gemini-1.5-pro', label: 'Google Gemini 1.5 Pro', price: '$7 in / $21 out per MTok', provider: 'Google' },
    ],
    useCase: "Gold-standard evaluator (LLM-as-judge), complex workflows needing long context, strategic tasks"
  }
];

// Flattened array of all models for simple selects
export const allModels: LLMModel[] = modelCategories.flatMap(category => category.models);